export enum ReducerActionType {
  FEEDBACK_INIT,
  LESSON_SELECTED,
  LESSON_SUBMITTED,
  LESSON_RESET,
  RESTORE_SUBMITTED_LESSON,
}

type FeedbackInitAction = {
  type: ReducerActionType.FEEDBACK_INIT;
  payload: { classroomId: number; teacherId: number; studentId: number };
};

type LessonSelectedAction = {
  type: ReducerActionType.LESSON_SELECTED;
  payload: { lessonId: number };
};

type LessonSubmittedAction = {
  type: ReducerActionType.LESSON_SUBMITTED;
  payload: object;
};

type LessonResetAction = {
  type: ReducerActionType.LESSON_RESET;
  payload: object;
};

type RestoreSubmittedLessonAction = {
  type: ReducerActionType.RESTORE_SUBMITTED_LESSON;
  payload: {
    classroomId: number;
    teacherId: number;
    studentId: number;
    lessonId: number;
  };
};

export type ReducerAction =
  | FeedbackInitAction
  | LessonSelectedAction
  | LessonSubmittedAction
  | LessonResetAction
  | RestoreSubmittedLessonAction;
